import { Checkbox } from '@microservices/wiskey-react-components'
import { CellContext, ColumnDef } from '@tanstack/react-table'

export const getVisibilityColumn = <T,>(
  showVisibilityColumn: boolean,
  disabledVisibilityColumn: boolean
) => {
  // const onHide = table.options.meta?.onHide
  return showVisibilityColumn
    ? [
        {
          accessorKey: 'visibility',
          header: 'Enabled',
          enableSorting: false,
          cell: (props: CellContext<T & { visibility: boolean }, unknown>) => (
            <Checkbox
              checked={props.row.original.visibility}
              disabled={disabledVisibilityColumn}
              sx={{ height: 30 }}
              onChange={(_e, checked) => props.table.options.meta?.onHide?.(props, checked)}
            />
          ),
          minSize: 80,
          size: 80,
        } as ColumnDef<T>,
      ]
    : []
}
